import { render, staticRenderFns } from "./GenderAge.vue?vue&type=template&id=55206d5a&scoped=true&"
import script from "./GenderAge.vue?vue&type=script&lang=js&"
export * from "./GenderAge.vue?vue&type=script&lang=js&"
import style0 from "./GenderAge.vue?vue&type=style&index=0&id=55206d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55206d5a",
  null
  
)

export default component.exports